"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _react = _interopRequireDefault(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _reactRedux = require("react-redux");
var _configuratorCarousel = require("@mmc/configurator-carousel");
var _configuratorColourSelector = require("@mmc/configurator-colour-selector");
var _mmcDataUtilities = _interopRequireDefault(require("@mmc-tools/mmc-data-utilities"));
var _text = require("@mmc/text");
var _disclaimer = _interopRequireDefault(require("./disclaimer/disclaimer"));
var _configurator = _interopRequireDefault(require("../styles/configurator.css"));
var _actions = require("../actions");
var _DataUtils = new _mmcDataUtilities["default"](),
  isEmptyArray = _DataUtils.isEmptyArray;
var ColorSelector = /*#__PURE__*/function (_React$Component) {
  function ColorSelector(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    _this.changeColor = _this.changeColor.bind(_this);
    return _this;
  }
  (0, _inheritsLoose2["default"])(ColorSelector, _React$Component);
  var _proto = ColorSelector.prototype;
  _proto.componentDidMount = function componentDidMount() {
    var _this$props = this.props,
      color = _this$props.color,
      preferences = _this$props.preferences,
      updateSelections = _this$props.updateSelections,
      data = _this$props.data,
      dispatch = _this$props.dispatch;
    var filter = data.filter || {};
    var filteringOptions = filter.filteringOptions || [];
    var selectedColorCode = color;
    var preSelectedColor = filteringOptions.find(function (currentColor) {
      return currentColor.selected === true;
    });

    // Check if currently configured color is available
    if (!this.checkColorIsValid(selectedColorCode)) {
      // Use preference if it is valid
      if (this.checkColorIsValid(preferences.color)) {
        selectedColorCode = preferences.color;
        // Use hero colour if it was supplied
      } else if (preSelectedColor) {
        if (preSelectedColor.code) {
          selectedColorCode = preSelectedColor.code;
        }
        // Use first option
      } else if (filteringOptions) {
        if (filteringOptions[0]) {
          selectedColorCode = filteringOptions[0].code;
        }
      }
      dispatch((0, _actions.setColor)(selectedColorCode));
    }

    // Set our app configuration to match
    updateSelections({
      color: selectedColorCode
    });
  };
  _proto.checkColorIsValid = function checkColorIsValid(color) {
    var isValid = false;
    var data = this.props.data;
    var filter = data.filter || {};
    var filteringOptions = filter.filteringOptions || [];
    if (color !== '' && color !== undefined && color !== null) {
      if (filteringOptions.find(function (currentColor) {
        return currentColor.code === color;
      })) {
        isValid = true;
      }
    }
    return isValid;
  };
  _proto.changeColor = function changeColor(e) {
    var dispatch = this.props.dispatch;
    dispatch((0, _actions.setColor)(e.target.value));
  };
  _proto.render = function render() {
    var _this$props2 = this.props,
      color = _this$props2.color,
      minorQueryPending = _this$props2.minorQueryPending,
      data = _this$props2.data,
      _this$props2$theme = _this$props2.theme,
      theme = _this$props2$theme === void 0 ? {} : _this$props2$theme,
      direction = _this$props2.direction,
      market = _this$props2.market,
      disclaimerData = _this$props2.disclaimerData;
    var filter = data.filter,
      headingText = data.headingText;
    var carousel = data.carousel || {};
    var colorSelectorData = {
      filter: filter,
      headingText: headingText
    };
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _clsx["default"])(theme['container-fluid'], _configurator["default"].stepContent)
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: theme.row
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _clsx["default"])(theme['col-xs-12'], theme['col-sm-6'])
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _clsx["default"])(theme.row, _configurator["default"].loaderWrapper)
    }, !isEmptyArray(carousel.items) && /*#__PURE__*/_react["default"].createElement(_configuratorCarousel.ConfiguratorCarousel, {
      theme: theme,
      data: carousel,
      isLoading: minorQueryPending > 0
    }))), /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _clsx["default"])(theme['col-xs-12'], theme['col-sm-6'], theme.marginBottom40),
      dir: direction
    }, /*#__PURE__*/_react["default"].createElement(_configuratorColourSelector.ConfiguratorColourSelector, {
      theme: theme,
      data: colorSelectorData,
      changeEvent: this.changeColor,
      selectedCard: color,
      disclaimerData: disclaimerData
    }), data.disclaimer && market !== 'us' && /*#__PURE__*/_react["default"].createElement("p", {
      className: theme.smallType + " " + _configurator["default"].stepDisclaimer
    }, data.disclaimer)), data.disclaimer && market === 'us' && /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _clsx["default"])(theme['col-xs-12'], theme['col-md-offset-1'], theme['col-md-10'])
    }, /*#__PURE__*/_react["default"].createElement(_disclaimer["default"], {
      theme: theme,
      headline: "Disclaimer",
      content: data.disclaimer
    }))));
  };
  return ColorSelector;
}(_react["default"].Component);
var mapStateToProps = function mapStateToProps(state, props) {
  return {
    color: state.color.value,
    theme: props.theme,
    preferences: props.preferences,
    data: props.data,
    updateSelections: props.updateSelections
  };
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, function (dispatch) {
  return {
    dispatch: dispatch
  };
})(ColorSelector);